// interactive
import './interactive/ImportScript';
import './interactive/Header';
import './interactive/Accordion';
import './interactive/Tab';
import './interactive/Modal';
import './interactive/Tree';
import './interactive/Validate';

/* https://codesandbox.io/s/scroll-to-element-vanilla-js-prk7e?from-embed=&file=/src/index.js:198-313 */

//import { scrollTo } from "./interactive/scrollTo";

//const button = document.getElementById("scrollToIntroButton");
//button.onclick = () => scrollTo({ id: "contact" });

(function ($) {
    $(document).on('click', '.nav-menu a, .ikutan-nav a, .quickMeal-btn-lg a, .quickMeal-btn-sm a, .mobile-nav a, .scrollto', function(e) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            e.preventDefault();
            var target = $(this.hash);
  
            if (target.length) {
                var scrollto = target.offset().top -100;
                var scrolled = 2;
  
                // if ($('#header-sticky-wrapper').length) {
                //     scrollto -= $('#header-sticky-wrapper').outerHeight() - scrolled;
                // }
  
                if ($(this).attr("href") == '#header') {
                    scrollto = 0;
                }
  
                $('html, body').animate({
                    scrollTop: scrollto
                }, 1500, 'easeInOutExpo');
  
                if ($(this).parents('.nav-menu, .ikutan-nav a, .quickMeal-btn-lg a, .quickMeal-btn-sm a, .mobile-nav').length) {
                    $('.nav-menu .active, .ikutan-nav a, .quickMeal-btn-lg a, .quickMeal-btn-sm a, .mobile-nav .active').removeClass('active');
                    //$(this).closest('li').addClass('active');
                }
  
                // if ($('body').hasClass('mobile-nav-active')) {
                //     $('body').removeClass('mobile-nav-active');
                //     $('.mobile-nav-toggle i').toggleClass('icofont-navigation-menu icofont-close');
                //     $('.mobile-nav-overly').fadeOut();
                // }
  
                return false;
            }
        }
    });

    // Back to top button
    $(window).scroll(function() {
    	if ($(this).scrollTop() > 100) {
    		$('.back-to-top').fadeIn('slow');
    	} else {
    		$('.back-to-top').fadeOut('slow');
    	}
    });

    $('.back-to-top').click(function() {
    	$('html, body').animate({
    		scrollTop: 0
    	}, 1500, 'easeInOutExpo');
    	return false;
    });

})(jQuery);